<template>
  <div class="posts">
    <transition-group name="fade" mode="in-out">
      <div v-for="(post, index) in this.filteredPosts" :key="'post-'+index" class="post">
        <WordsOfWisdomPost :post="post"></WordsOfWisdomPost>
      </div>
    </transition-group>
  </div>
</template>

<script>
import axios from 'axios';
import WordsOfWisdomPost from './components/WordsOfWisdomPost'

export default {
  name: 'WordsOfWisdom',
  data() {
    return {
      posts: [],
      currentCategory: '',
      showFirstLoad: 5,
      postCount: 0
    }
  },
  props: [
    'limit'
  ],
  components: {
    WordsOfWisdomPost
  },
  methods: {
    categoryClickHandler(category) {
      this.currentCategory = category
      this.postCount = this.showFirstLoad
    },
  },
  mounted() {
    axios.get(`${window.location.origin}/wp-json/wp/v2/posts?_embed`)
    .then(response => {
      this.posts = response.data
    })

    window.addEventListener('update-expertise', (event) => {
      this.categoryClickHandler(event.detail.category)
    });
    window.addEventListener('load-more-words-of-wisdom', () => {
        this.workCount += 6;
        if(this.showLoadMore === false) {
          window.dispatchEvent(new CustomEvent('show-load-more-words-of-wisdom', {
            detail: {
              hide: 'true'
            }
          }));
        }
    });
  },
  computed: {
    filteredPosts() {
      let self = this
        return this.posts.filter(post => {
          let match = false
          if(self.currentCategory != '') {
            if(!post._embedded['wp:term'] || post._embedded['wp:term'].length == 0) return false;
            post._embedded['wp:term'].forEach(term => {
              term.forEach(t => {
                if(t.id === this.currentCategory.id) {
                  match = true
              }
              })
            })
            return match
          }
          else {
            return true
          }
        }).slice(0, this.limit)
    }
  }
}
</script>

<style lang="scss">
.posts {
  padding: 20px;

  @media screen and (min-width: 640px) {
    padding: 0;
  }

  span {
    display: flex;
    flex-wrap: wrap;
  }
}
/* .post:first-of-type .post__image {
  width: 800px;
} */
.fade-enter-active, .fade-leave-active {
  transition: opacity .3s ease;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
